module.exports = __webpack_public_path__ + "img/p16.acad7d48.png";